var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3C12.4526 3 13.2244 3.7721 13.2246 4.72461V10.2002H18.3252C19.3192 10.2003 20.125 11.006 20.125 12C20.125 12.994 19.3192 13.7997 18.3252 13.7998H13.2246V19.2754C13.2244 20.2279 12.4526 21 11.5 21C10.5474 21 9.7756 20.2279 9.77539 19.2754V13.7998H4.6748C3.68078 13.7997 2.875 12.994 2.875 12C2.875 11.006 3.68078 10.2003 4.6748 10.2002H9.77539V4.72461C9.7756 3.7721 10.5474 3 11.5 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.7ca0e6ba.svg";
export { ForwardRef as ReactComponent };